import React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Box } from "@mui/material";
import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  yellowColor,
  grayColor,
  defaultFont,
} from "../../assets/jss/material-dashboard-react";

const headerColorMap = {
  warning: warningColor[0],
  primary: primaryColor[0],
  danger: dangerColor[0],
  success: successColor[0],
  info: infoColor[0],
  rose: roseColor[0],
  yellow: yellowColor[0],
  gray: grayColor[0],
};

export default function CustomTable({
  tableHead,
  tableData,
  tableHeaderColor = "gray", // Parâmetro padrão
}) {
  const headerColor = headerColorMap[tableHeaderColor] || grayColor[0];

  return (
    <Box
      sx={{
        width: "100%",
        mt: 3,
        maxHeight: "450px",
        overflowX: "auto",
      }}
    >
      <Table
        sx={{
          marginBottom: 0,
          width: "100%",
          maxWidth: "100%",
          backgroundColor: "transparent",
          borderSpacing: 0,
          borderCollapse: "collapse",
        }}
      >
        {tableHead !== undefined && (
          <TableHead>
            <TableRow
              sx={{
                height: "56px",
                color: "inherit",
                verticalAlign: "middle",
              }}
            >
              {tableHead.map((prop, key) => (
                <TableCell
                  key={key}
                  align="center"
                  sx={{
                    color: headerColor,
                    fontSize: "1em",
                    ...defaultFont,
                  }}
                >
                  {prop}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {tableData !== undefined &&
            tableData.map((rowObj, key) => (
              <TableRow
                key={key}
                sx={{
                  height: "48px",
                  color: "inherit",
                  verticalAlign: "middle",
                }}
              >
                {rowObj.row.map((cell, key2) => (
                  <TableCell
                    key={key2}
                    align="center"
                    sx={{
                      ...defaultFont,
                      lineHeight: "1.42857143",
                      padding: "12px 8px",
                      verticalAlign: "middle",
                      fontSize: "0.8125rem",
                    }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Box>
  );
}

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "yellow",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};
